import axios from 'axios'

let baseUrl = 'https://api.roadcube.io/v1/';
let idToken = '5be37664-87a8-4969-adb4-600d0555b9b8';

axios.defaults.baseURL = baseUrl;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['X-Web-App-Token'] = idToken;
axios.defaults.headers.common['X-Locale'] = 'el';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

